import * as API from "utils/api"
import { APIResponse } from "./types"

//新規公開銘柄
const IPOSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/IPOSymbol", params, headers)
}

const GetIPOSchedule: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Equity/Message/GetIPOSchedule",
    params,
    headers
  )
}

const GetIPOSchedulePast: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Equity/Message/GetIPOSchedulePast",
    params,
    headers
  )
}

const BookBuilding: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Equity/Message/ChangedBookBuildingSymbol",
    params,
    headers
  )
}

const ChangedBusinessNameSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ChangedBusinessNameSymbol",
    params,
    headers
  )
}

const ChangedListingSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ChangedListingSymbol",
    params,
    headers
  )
}

const ListingDelaySymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Equity/Message/ListingDelaySymbol",
    params,
    headers
  )
}

const ListingSuspensionSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ListingSuspensionSymbol",
    params,
    headers
  )
}

const SupervisionSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SupervisionSymbol",
    params,
    headers
  )
}

const DelistedSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/DelistedSymbol",
    params,
    headers
  )
}

const SuspensionSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SuspensionSymbol",
    params,
    headers
  )
}

const ChangedUnitSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ChangedUnitSymbol",
    params,
    headers
  )
}

const MergeredSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/MergeredSymbol",
    params,
    headers
  )
}

const ChangedCapitalSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ChangedCapitalSymbol",
    params,
    headers
  )
}

const ChangedFinanceSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/ChangedFinanceSymbol",
    params,
    headers
  )
}

const StableSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/StableSymbol", params, headers)
}

const LimitSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request("GET", "Equity/Message/LimitSymbol", params, headers)
}

const NewMergeredSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/NewMergeredSymbol",
    params,
    headers
  )
}

const StockExchangeTransfer: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/StockExchangeTransfer",
    params,
    headers
  )
}

const SymbolCapitalMovements: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SymbolCapitalMovements",
    params,
    headers
  )
}

const SymbolCorporateChanges: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SymbolCorporateChanges",
    params,
    headers
  )
}

export default {
  IPOSymbol,
  GetIPOSchedule,
  GetIPOSchedulePast,
  BookBuilding,
  ChangedBusinessNameSymbol,
  ChangedListingSymbol,
  ListingDelaySymbol,
  ListingSuspensionSymbol,
  SupervisionSymbol,
  DelistedSymbol,
  SuspensionSymbol,
  ChangedUnitSymbol,
  MergeredSymbol,
  ChangedCapitalSymbol,
  ChangedFinanceSymbol,
  StableSymbol,
  LimitSymbol,
  SymbolCapitalMovements,
  SymbolCorporateChanges,
  NewMergeredSymbol,
  StockExchangeTransfer,
}
